const operatorEndpoints = {
    getOperatorInfo: "/products/operatorInfo",
    getListOperator: "/royalprogram/getListOperators",
  };
  
export default operatorEndpoints;